import { ConfirmDialog } from '@/components/confirm-dialog'
import { toast } from 'sonner'
import { useAgents } from '../context/agents-context'
import { AgentService } from '@/services/agent.service'

interface AgentsDialogsProps {
  onDeleteSuccess?: () => void
}

export function AgentsDialogs({ onDeleteSuccess }: AgentsDialogsProps) {
  const { open, setOpen, currentRow, setCurrentRow } = useAgents()

  return (
    <>
      {currentRow && (
        <ConfirmDialog
          key='agent-delete'
          destructive
          open={open === 'delete'}
          onOpenChange={() => {
            setOpen('delete')
            setTimeout(() => {
              setCurrentRow(null)
            }, 100)
          }}
          handleConfirm={() => {
            setOpen(null)
            setTimeout(() => {
              setCurrentRow(null)
            }, 100)
            toast.promise(AgentService.delete(currentRow.id), {
              loading: 'Excluindo agente...',
              success: () => {
                onDeleteSuccess?.()
                return 'Agente excluído com sucesso'
              },
              error: () => {
                onDeleteSuccess?.()
                return 'Erro ao excluir agente.'
              },
            })
          }}
          className='max-w-md'
          title={`Excluir este agente: ${currentRow.name}?`}
          desc={
            <>
              Você está prestes a excluir o agente <strong>{currentRow.name}</strong>. <br />
              Esta ação não pode ser revertida.
            </>
          }
          confirmText='Excluir'
        />
      )}
    </>
  )
}
